import ListUser from '../login.User.List.i18n';
import ListAdmin from '../login.Admin.List.i18n';
import ListPartner from '../login.Partner.List.i18n';

export default {
  name : "loginList",
  props: ['user', 'auto_refresh'],
  components: { ListUser, ListAdmin, ListPartner, },
  data: () => ({
  }),
  computed: {
  },
  methods: {
  },
  created() { console.log('log.login.vue', 'created'); },
  destroyed() { console.log('log.login.vue', 'destroyed'); },
  mounted() {
    console.log('log.login.vue', 'mounted');
    if(this.auto_refresh == true) { this.sync.enable = this.auto_refresh; }
    if(this.user) {
      this.so.sk = 'addr'
      this.so.skt = 'Address'
    }
  },
}